import { NewUserData } from "@app/core/user/domain/new-user";

export class NewUserMapper {
  static serialize(newUserData: NewUserData): any {
    return {
      name: newUserData.name,
      last_name: newUserData.lastName,
      dni: newUserData.dni,
      date_birth: newUserData.dateOfBirth,
      email: newUserData.email,
      password: newUserData.password,
      accepted_policies: newUserData.acceptedPolicies,
      accepted_communications: newUserData.accepted_communications,
      adult: newUserData.adult,
      // If the image is not null, send it, otherwise, don't send it
      ...(newUserData.image ? { image: newUserData.image } : {}),
    };
  }
}
